<section class="area-login animate__animated animate__fadeIn" [ngStyle]="{ 'background-image': 'url(' + randomImage + ')' }">
  <mat-card
    [ngClass]="{'login':true, 'login-success animate__animated animate__fadeIn': step == 2, 'login-pdf': step == 3}"
    style="position: relative;">


    <mat-card-content>

      <div class="simpli-floating-box-header">
        <div class="simpli-floating-box-logo text-center">
          <img src="../../assets/simpli/simpli.svg" height="90px">
        </div>

        <div class="simpli-floating-box-title text-center">
          <span class="color-tertiary">
            Comienza tu simulación
          </span>
        </div>

        <div class="text-right" *ngIf="step == 2" style="width: 100%; display: flex; justify-content: flex-end;">
          <button mat-flat-button class="secondary-button" color="primary" (click)="goToPreviousStep()">
            Anterior
          </button>
          <button mat-flat-button class="primary-button" color="primary" [disabled]="enviandoBtn" (click)="sendPdf()">
            <span *ngIf="!enviandoBtn">Enviar a mi mail</span>
            <span *ngIf="enviandoBtn"><i class="fa-solid fa-spinner fa-spin-pulse"></i></span>
          </button>
        </div>

      </div>

      <div class="simpli-floating-box-body add_factoring">

        <div *ngIf="step == 1">


          <div class="row">

            <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12 col-top" *ngIf="subStep == 1">

              <form [formGroup]="valForm">

                <mat-form-field>
                  <mat-label>Nombre</mat-label>
                  <input matInput formControlName="name" required (input)="capitalizeName()" />
                  <mat-hint>Indique el nombre del inversionista</mat-hint>
                  <mat-error *ngIf="valForm.controls['name'].hasError('required')">
                    Nombre es <strong>requerido</strong>
                  </mat-error>
                </mat-form-field>


                <mat-form-field>
                  <mat-label>Correo electrónico</mat-label>
                  <input matInput formControlName="mail" type="email" required (input)="convertToLowerCase($event)" />
                  <mat-hint>Indique el correo electrónico</mat-hint>
                  <mat-error *ngIf="valForm.controls['mail'].hasError('required')">
                    Correo electrónico es <strong>requerido</strong>
                  </mat-error>
                  <mat-error *ngIf="valForm.controls['mail'].hasError('email')">
                    Correo electrónico no es <strong>válido</strong>
                  </mat-error>
                </mat-form-field>


                <mat-form-field>
                  <mat-label>RUT</mat-label>
                  <input matInput formControlName="rut" (input)="formatRUT($event)" required />
                  <mat-hint>Indique el RUT</mat-hint>
                  <mat-error *ngIf="valForm.controls['rut'].hasError('required')">
                    RUT es <strong>requerido</strong>
                  </mat-error>
                  <mat-error
                    *ngIf="valForm.controls['rut'].hasError('invalidRUT') && !valForm.controls['rut'].hasError('required')">
                    RUT no es <strong>válido</strong>
                  </mat-error>
                </mat-form-field>


                <mat-form-field>
                  <!-- <mat-label>Teléfono</mat-label> -->
                  <input matInput type="text" maxlength="9" formControlName="telefono" placeholder="Télefono" required>
                  <span matTextPrefix>+56&nbsp;</span>
                  <mat-hint>Ingrese el número de 9 dígitos del contacto.</mat-hint>
                  <mat-error *ngIf="valForm.controls['telefono'].hasError('required')">
                    Teléfono es <strong>requerido</strong>
                  </mat-error>
                  <mat-error *ngIf="valForm.controls['telefono'].hasError('pattern')">
                    El número de teléfono debe ser de <strong>9 dígitos</strong>
                  </mat-error>
                </mat-form-field>

              </form>

            </div>

            <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12 col-top" *ngIf="subStep == 2">

              <form [formGroup]="formGroup">

                <mat-form-field>
                  <!-- <mat-label>Monto</mat-label> -->
                  <input placeholder="Monto" matInput type="text" (keyup)="formatMonto($event)" formControlName="monto"
                    required>
                  <span matTextPrefix>$&nbsp;</span>
                  <mat-hint>Indique el monto</mat-hint>
                  <mat-error *ngIf="formGroup.controls['monto'].hasError('required')">
                    Monto es <strong>requerido</strong>
                  </mat-error>
                  <mat-error *ngIf="formGroup.controls['monto'].hasError('invalidMonto')">
                    Monto es <strong>inválido</strong>
                  </mat-error>
                  <mat-error *ngIf="formGroup.controls['monto'].hasError('montoMinimo')">
                    Monto debe ser al menos <strong>$500.000</strong>
                  </mat-error>
                </mat-form-field>

                <mat-form-field>
                  <mat-label>Fecha emisión</mat-label>
                  <input matInput [matDatepicker]="picker" formControlName="fechaEmision" required />
                  <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
                  <mat-datepicker #picker></mat-datepicker>
                  <mat-hint>Seleccione la fecha de emisión</mat-hint>
                  <mat-error *ngIf="formGroup.controls['fechaEmision'].hasError('required')">
                    Fecha de emisión es <strong>requerida</strong>
                  </mat-error>
                </mat-form-field>

                <mat-form-field>
                  <mat-label>Plazo (meses)</mat-label>
                  <input matInput formControlName="plazo" type="number" (wheel)="$event.preventDefault()" required />
                  <mat-hint>Indique el plazo en meses</mat-hint>
                  <mat-error *ngIf="formGroup.controls['plazo'].hasError('required')">
                    Plazo es <strong>requerido</strong>
                  </mat-error>
                  <mat-error *ngIf="formGroup.controls['plazo'].hasError('pattern')">
                    El plazo debe ser un <strong>número entero</strong>
                  </mat-error>
                  <mat-error *ngIf="formGroup.controls['plazo'].hasError('min')">
                    El plazo debe ser mínimo <strong>3 meses</strong>
                  </mat-error>
                </mat-form-field>


                <mat-form-field>
                  <mat-label>Retiro</mat-label>
                  <mat-select formControlName="retiro" required>
                    <mat-option value="Mensual">Mensual</mat-option>
                    <mat-option value="Al vencimiento">Al vencimiento</mat-option>
                  </mat-select>
                  <mat-hint>Seleccione el tipo de retiro</mat-hint>
                  <mat-error *ngIf="formGroup.controls['retiro'].hasError('required')">
                    Tipo de retiro es <strong>requerido</strong>
                  </mat-error>
                </mat-form-field>

                <mat-form-field class="hidden">
                  <mat-label>Cliente</mat-label>
                  <mat-select formControlName="cliente" required>
                    <mat-option value="Interno">Interno</mat-option>
                    <mat-option value="Externo">Externo</mat-option>
                  </mat-select>
                  <mat-hint>Seleccione el tipo de cliente</mat-hint>
                  <mat-error *ngIf="formGroup.controls['cliente'].hasError('required')">
                    Tipo de cliente es <strong>requerido</strong>
                  </mat-error>
                </mat-form-field>

                <mat-form-field class="hidden">
                  <mat-label>Tasa (opcional)</mat-label>
                  <input matInput type="number" formControlName="tasa">
                  <mat-hint>Ingrese una tasa con hasta 4 decimales.</mat-hint>
                  <mat-error *ngIf="formGroup.controls['tasa'].hasError('maxFourDecimals')">
                    La tasa debe tener como máximo <strong>4 decimales</strong>
                  </mat-error>
                </mat-form-field>

              </form>

            </div>


          </div>


          <div class="btn-container">

            <button mat-flat-button class="primary-button smr" type="button" *ngIf="subStep == 1"
              (click)="siguiente_paso($event, this.valForm.value, 1)">Siguiente</button>

            <button mat-flat-button class="primary-button smr mt-20" type="button" *ngIf="subStep == 2"
              (click)="siguiente_paso($event, this.formGroup.value, 2)" [disabled]="enviandoBtn">
              <span *ngIf="!enviandoBtn">Siguiente</span>
              <span *ngIf="enviandoBtn"><i class="fa-solid fa-spinner fa-spin-pulse"></i></span>
            </button>

          </div>

        </div>

        <div *ngIf="step == 2">
          <app-resultado-simulacion [stepper]="stepper" [parent]="this" [isPublicSimulation]="true" />
        </div>

        <div *ngIf="step == 3">
          <app-pdf-simulacion [stepper]="stepper" />
        </div>


      </div>


      <div class="center-div">
        <a mat-button class="label-button" (click)="navigateToLogin()" *ngIf="step == 1 && subStep == 1">Volver</a>
        <a mat-button class="label-button" (click)="onVolver()" *ngIf="step == 1 && subStep == 2">Volver</a>
      </div>

    </mat-card-content>


  </mat-card>

</section>